/* eslint-disable consistent-return */
/* eslint-disable no-param-reassign */
import moment from 'moment';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';
import isArray from 'lodash/isArray';

import PropertiesService from 'aurora-composition/services/propertyService';
import DocumentService from 'aurora-composition/services/documentService';
import OwnerService from 'aurora-composition/services/ownerService';
import MortgageService from 'aurora-composition/services/mortgageService';
import { getPropertType } from 'aurora-utils/utils';
import AuthService from 'aurora-composition/services/authService';
import * as types from './constants';

export const fetchProperySuccess = property => ({
  type: types.FETCH_PROPERTY_DETAILS_SUCCESS,
  payload: {
    property,
  },
});
export const fetchProperySuccessMap = map => ({
  type: types.FETCH_PROPERTY_DETAILS_SUCCESS_MAP,
  payload: {
    map,
  },
});
export const fetchProperyError = error => ({
  type: types.FETCH_PROPERTY_DETAILS_ERROR,
  payload: {
    error,
  },
});

export const getPropertyDetails = (data, units, type) => {
  const locale = localStorage.getItem('lang');
  const propertyDetails = {};
  propertyDetails.canInitiateService = data?.canInitiateService;
  propertyDetails.propertyId = data?.propertyID;
  propertyDetails.plotNumber = data?.plotNumber;
  propertyDetails.unitRegistrationNumber = data?.unitRegistrationNumber;
  propertyDetails.propertyType = data?.propertyType;
  propertyDetails.municipalityID = data?.municipalityID || null;
  propertyDetails.muncipalityEn = data?.muncipalityEn;
  propertyDetails.muncipalityAr = data?.muncipalityAr;
  propertyDetails.districtId = data?.districtId || null;
  propertyDetails.districtEn = data?.districtEn;
  propertyDetails.districtAr = data?.districtAr;
  propertyDetails.communityId = data?.communityId || null;
  propertyDetails.communityEn = data?.communityEn;
  propertyDetails.communityAr = data?.communityAr;
  propertyDetails.serviceStatusAr = data?.serviceStatusAr;
  propertyDetails.serviceStatusEn = data?.serviceStatusEn;
  propertyDetails.unitClassificationId = data?.unitClassificationId || null;
  propertyDetails.unitClassificationEn = data?.unitClassificationEn;
  propertyDetails.unitClassificationAr = data?.unitClassificationAr;
  propertyDetails.unitClassificationId = data?.unitClassificationId || null;
  propertyDetails.landUseAr = data?.landUseAr;
  propertyDetails.landUseEn = data?.landUseEn;
  propertyDetails.landSize = data?.landSize;
  propertyDetails.plotAddress = data?.plotAddress;
  propertyDetails.projectId = data?.projectId;
  propertyDetails.projectNameEn = data?.projectNameEn;
  propertyDetails.projectNameAr = data?.projectNameAr;
  propertyDetails.buildingNumber = data?.buildingNumber;
  propertyDetails.buildingRegNumber = data?.propertyBuildingRegNum || data?.buildingRegNumber;
  propertyDetails.floorNumber = data?.floorNumber;
  propertyDetails.floorCount = data?.floorCount;
  propertyDetails.unitsCount = data?.unitsCount;
  propertyDetails.premiseNumber = data?.premiseNumber;
  propertyDetails.sharedPremiseNumber = data?.sharedPremiseNumber;
  propertyDetails.bedroomCount = data?.bedroomCount;
  propertyDetails.bathrooms = data?.bathrooms;
  propertyDetails.unitNumber = data?.unitNumber;
  propertyDetails.parking = data?.parking;
  propertyDetails.unitArea = data?.unitArea;
  propertyDetails.onCommercialAxis = data?.onCommercialAxis;
  propertyDetails.onInvestmentAxis = data?.onInvestmentAxis;
  propertyDetails.constructionStatusEn = data?.constructionStatusEn;
  propertyDetails.constructionStatusAr = data?.constructionStatusAr;
  propertyDetails.constructionStatusAr = data?.constructionStatusAr;
  propertyDetails.roadNumber = data?.roadNumber;
  propertyDetails.constructionStatus = data?.constructionStatus;
  propertyDetails.propertyDimensions = data?.propertyDimensions;
  propertyDetails.propertyRegistrationNumber = data?.propertyRegistrationNumber;
  propertyDetails.notes = data?.notes;
  propertyDetails.legalNotes = data?.legalNotes;
  propertyDetails.contractDetail = null;
  propertyDetails.tenant = false;
  propertyDetails.isOffPlan = data?.isOffPlan;
  propertyDetails.musatahaContracts = data?.musatahaContracts;
  const contractDetailsObj = {};
  const contractDetail = data?.contractDetail;
  if (contractDetail) {
    contractDetailsObj.contractId = contractDetail?.contractId;
    contractDetailsObj.applicationId = contractDetail?.applicationId;
    contractDetailsObj.contractNo = contractDetail?.contractNo;
    contractDetailsObj.contractAmount = contractDetail?.contractAmount;
    contractDetailsObj.status = contractDetail?.contractStatusEn;
    contractDetailsObj.contractStartDate = moment(contractDetail?.contractStartDate).format('DD-MM-YYYY');
    contractDetailsObj.contractEndDate = moment(contractDetail?.contractEndDate).format('DD-MM-YYYY');
    contractDetailsObj.tenant = contractDetail?.tenant;
    contractDetailsObj.pmaContractExist = contractDetail?.pmaContractExist;
    contractDetailsObj.allowFirstPartyAccess = contractDetail?.allowFirstPartyAccess;
    contractDetailsObj.tenantCustomerId = contractDetail?.tenantCustomerId;

    propertyDetails.tenant = contractDetail?.tenant || false;
    if (locale === 'en') {
      contractDetailsObj.tenantName = contractDetail?.tenantNameEn;
      contractDetailsObj.contractStatus = contractDetail?.contractStatusEn;
    } else {
      contractDetailsObj.tenantName = contractDetail?.tenantNameAr;
      contractDetailsObj.contractStatus = contractDetail?.contractStatusAr;
    }
    propertyDetails.contractDetail = contractDetailsObj;
  }
  propertyDetails.type = getPropertType(data?.propertyType);
  const owners = [];
  if (data?.ownerships) {
    data?.ownerships?.forEach(owner => {
      const ownerObj = {};
      ownerObj.ownerNameEn = owner?.ownerNameEn;
      ownerObj.ownerNameAr = owner?.ownerNameAr;
      ownerObj.ownerShare = owner?.ownerShare;
      ownerObj.eidNumber = owner?.eidNumber;
      ownerObj.rightHoldTypeEn = owner?.rightHoldTypeEn;
      ownerObj.moiUnifiedNumber = owner?.moiUnifiedNumber;
      ownerObj.archiveNumber = owner?.archiveNumber;
      ownerObj.priority = owner?.priority;
      ownerObj.remarks = owner?.remarks;
      ownerObj.chamberAndIndustryNumber = owner?.chamberAndIndustryNumber;
      ownerObj.licenseNumber = owner?.licenseNumber;
      ownerObj.fileNumber = owner?.fileNumber;
      ownerObj.ownerTypes = owner?.ownerType;
      ownerObj.isOffPlan = owner?.isOffPlan;
      ownerObj.phone = owner?.phone;
      ownerObj.email = owner?.email;
      if (locale === 'en') {
        ownerObj.ownerName = owner?.ownerNameEn;
        ownerObj.nationality = owner?.nationalityEn;
        ownerObj.ownershipMethod = owner?.ownershipMethodEn;
        ownerObj.rightHoldType = owner?.rightHoldTypeEn;
      } else {
        ownerObj.ownerName = owner?.ownerNameAr;
        ownerObj.nationality = owner?.nationalityAr;
        ownerObj.ownershipMethod = owner?.ownershipMethodAr;
        ownerObj.rightHoldType = owner?.rightHoldTypeAr;
      }
      owners.push(ownerObj);
    });
  }
  propertyDetails.ownerships = owners;
  propertyDetails.contracts = data?.contracts;
  const allotments = [];
  data?.allotments?.forEach(allotment => {
    const allotmentObj = {};
    allotmentObj.allotmentDate = allotment?.allotmentDate;
    allotmentObj.applicationDate = allotment?.applicationDate;
    if (locale === 'en') {
      allotmentObj.allotmentSource = allotment?.allotmentSourceEn;
      allotmentObj.allotmentType = allotment?.allotmentTypeEn;
    } else {
      allotmentObj.allotmentSource = allotment?.allotmentSourceAr;
      allotmentObj.allotmentType = allotment?.allotmentTypeAr;
    }
    allotments.push(allotmentObj);
  });
  propertyDetails.allotments = allotments;
  const projectDetailsObj = [];
  data?.projectDetails?.forEach(projectDetail => {
    const obj = {};
    obj.projectNumber = projectDetail?.projectNumber;
    obj.startDate = moment(projectDetail?.projectDate).format('DD-MM-YYYY');
    obj.isBuildingCompleted = projectDetail?.isBuildingCompleted;
    if (locale === 'en') {
      obj.projectName = projectDetail?.projectNameEn;
      obj.developerName = projectDetail?.projectNameEn;
    } else {
      obj.projectName = projectDetail?.projectNameAr;
      obj.developerName = projectDetail?.projectNameAr;
    }
    projectDetailsObj.push(obj);
  });
  propertyDetails.projectDetails = projectDetailsObj;
  const availableMortgages = data?.mortgages;
  const filteredMortgageEn = availableMortgages?.filter(m => m.isActive === true);

  const mortgagesObj = [];
  let mortgageAmountEn = 0;
  let mortgageAmountAr = 0;
  filteredMortgageEn?.forEach(mortgage => {
    const obj = {};
    obj.amount = mortgage?.amount;
    mortgageAmountEn = Number(mortgageAmountEn) + Number(mortgage?.amount);
    mortgageAmountAr = +mortgage?.amount;
    obj.issueDate = moment(mortgage?.issueDate).format('DD-MM-YYYY');
    if (locale === 'en') {
      obj.bank = mortgage?.bankEn;
      obj.type = mortgage?.mortgageTypeEn;
    } else {
      obj.bank = mortgage?.bankAr;
      obj.type = mortgage?.mortgageTypeAr;
    }
    if (type === 'mortgage') {
      obj.allShares = mortgage?.allShares;
      obj.expiryDate = mortgage?.endDate && moment(mortgage?.endDate).format('DD-MM-YYYY');
      obj.contractNumber = mortgage?.contractNumber;
      obj.mortgageShares = mortgage?.mortgageShares;
      obj.mortgageTypeEn = mortgage?.mortgageTypeEn;
      obj.mortgageTypeAr = mortgage?.mortgageTypeAr;
      obj.isActive = true;
    }
    mortgagesObj.push(obj);
  });
  propertyDetails.mortgages = mortgagesObj;
  propertyDetails.blockings = data?.blockings;

  propertyDetails.endowmentContracts = data?.endowmentContracts;
  const unitsObj = [];
  units?.forEach(unit => {
    const obj = {};
    obj.unitNumber = unit?.unitNumber;
    obj.unitName = null;
    obj.propertyId = unit?.plotID;
    obj.unitUsage = locale === 'en' ? unit?.unitUsageNameEn : unit?.unitUsageNameAr;
    obj.isBlocked = unit?.isBlocked;
    obj.isLeased = unit?.isLeased;
    obj.isMortgaged = unit?.isMortgaged;
    obj.unitArea = unit?.unitArea;
    obj.bedrooms = unit?.bedroomCount;
    obj.unitRegNumber = unit?.unitRegistrationNumber;
    unitsObj.push(obj);
  });
  propertyDetails.units = unitsObj;
  propertyDetails.isBlocked = data?.isBlocked || data?.blockings?.length > 0;
  propertyDetails.morgaged = propertyDetails.mortgages?.length > 0;
  propertyDetails.leased = data?.isLeased || false;
  propertyDetails.ownershipType = `${data?.ownershipPercentage}% ${data?.ownerShipTypeNameEn}`;
  propertyDetails.amenities = data?.amenities;
  propertyDetails.industrialContracts = data?.industrialContracts;
  propertyDetails.allocationTypeEn = data?.allocationTypeEn;
  propertyDetails.allocationTypeAr = data?.allocationTypeAr;
  propertyDetails.constructionDate = data?.constructionDate;

  if (locale === 'en') {
    const propertyDetailsEn = {
      muncipality: data?.muncipalityEn,
      district: data?.districtEn,
      community: data?.communityEn,
      landUse: data?.landUseEn,
      buildingName: data?.buildingNameEn,
      unitClassification: data?.unitClassificationEn,
      unitUsageType: data?.unitUsageTypeEn,
      road: data?.roadEn,
      roadName: data?.roadEn,
      allocationType: data?.allocationTypeEn,
      mortgaeTotalAmount: mortgageAmountEn,
    };
    return { ...propertyDetails, ...propertyDetailsEn };
  }
  const propertyDetailsAr = {
    muncipality: data?.muncipalityAr,
    district: data?.districtAr,
    community: data?.communityAr,
    landUse: data?.landUseAr,
    buildingName: data?.buildingNameAr,
    unitClassification: data?.unitClassificationAr,
    unitUsageType: data?.unitUsageTypeAr,
    road: data?.roadAr,
    roadName: data?.roadAr,
    allocationType: data?.allocationTypeAr,
    mortgaeTotalAmount: mortgageAmountAr,
  };
  return { ...propertyDetails, ...propertyDetailsAr };
};
export const fetchPropery = (propertyId, type) => async dispatch => {
  try {
    dispatch({ type: types.FETCH_PROPERTY_DETAILS });
    let response = {};
    if (type === 'ownership' || type === 'mortgage') {
      response = await PropertiesService.fetchProperty(propertyId);
    } else {
      response = await PropertiesService.fetchPropertyLease(propertyId);
    }

    const data = response?.data?.result || response?.result;
    let units = [];
    if (data?.propertyType === 2) {
      const defaultFilter = {
        orderBy: '',
        orderByDirection: 1,
        pageSize: 100,
        pageNumber: 1,
        municipalityID: null,
        communityID: null,
        roadID: null,
        districtID: null,
        plotNumber: '',
        buildingId: data?.propertyID,
        floorNumber: '',
        unitNumber: '',
        propertyType: 4,
        landUseID: null,
        certificateNo: '',
      };

      const resp = await PropertiesService.fetchLeaseProperties(defaultFilter);

      units = resp?.result?.properties;
    }

    const propertDetailResponse = {};
    let propertyDetail = {};

    if (data) {
      propertyDetail = getPropertyDetails(data, units, type);
      propertDetailResponse.propertyDetails = propertyDetail;
      dispatch(fetchProperySuccess(propertDetailResponse));
    } else {
      propertDetailResponse.propertyDetails = null;
      dispatch(fetchProperySuccess(propertDetailResponse));
    }

    let map = null;
    try {
      const mapResponse = await DocumentService?.fetchPropertyMapById(propertyId);
      console.log(mapResponse?.bytes);
      map = mapResponse?.bytes;
    } catch (error) {
      map = null;
    }
    // propertDetailResponse.propertyDetails.map = map;
    // dispatch(fetchProperySuccess(propertDetailResponse));
    dispatch(fetchProperySuccessMap(map));
  } catch (e) {
    dispatch(fetchProperyError(e));
  }
};

// Actions V2
const operationStart = () => ({
  type: types.PROPERTY_OPERATION_START,
});

const operationEnd = error => ({
  type: types.PROPERTY_OPERATION_END,
  payload: { error: error?.data?.result?.description || error?.message },
});

export const fetchLeasePropertiesV2 = ({ page, PAGE_SIZE, propertyType, filters, defaultFilters, isPMABank }) => async (
  dispatch,
  getState,
) => {
  try {
    dispatch(operationStart());

    const { query, properties } = getState().propertiesReducer;

    const payload = {
      pageNumber: +page,
      pageSize: PAGE_SIZE,
      propertyType: propertyType && +propertyType,
      ...(isPMABank && { mortgageTypeId: 1001, searchFlags: 2 }),
      ...(filters?.municipality && { municipalityID: +filters.municipality }),
      ...(filters?.district && { districtID: +filters.district }),
      ...(filters?.community && { communityID: +filters.community }),
      ...(filters?.plotNumber && { plotNumber: filters.plotNumber }),
      ...(filters?.plotAddress && { plotAddress: filters.plotAddress }),
      ...(filters?.isBlocked && { isBlocked: filters?.isBlocked === '1' || filters?.isBlocked === 1 }),
      orderByDirection: 1,
      ...(!isEmpty(filters?.bedrooms) && {
        bedrooms: [...(filters?.bedrooms || [])]?.map(item => +item),
      }),
      ...(filters?.rentStatus && { rentStatus: filters.rentStatus === '1' }),
      ...(filters?.poaOnly && { poaOnly: filters.poaOnly === 'true' }),
      ...(filters?.tenantOnly && { tenantOnly: filters.tenantOnly === 'true' }),
      ...(filters?.propertyRegNo && { propertyRegNo: `${filters.propertyRegNo}` }),
      ...(filters?.unitRegNo && { unitRegNo: `${filters.unitRegNo}` }),
      ...(filters?.buildingNumber && { buildingNumber: filters.buildingNumber }),
      ...(filters?.unitNumber && { unitNumber: filters.unitNumber }),
      ...(filters?.useType && { isResidential: filters.useType === '1', isCommercial: filters.useType === '2' }),
      ...(filters?.ownershipPoaProperty && { ownershipPoaProperty: +filters.ownershipPoaProperty }),
      ...(filters?.premiseId && { premiseNumber: filters?.premiseId }),
      ...(filters?.buildingRegNumber && { propertyRegNo: `${filters.buildingRegNumber}` }),
      ...(!isEmpty(filters?.poaCustomerIds) && {
        poaCustomerIds: isArray(filters?.poaCustomerIds)
          ? [...(filters?.poaCustomerIds || [])]?.map(id => +id)?.toString()
          : [+filters?.poaCustomerIds]?.toString(),
      }),

      ...defaultFilters,
    };
    if (isEqual(query, JSON.stringify(payload)) && properties != null) {
      dispatch({
        type: types.FETCH_LEASE_PROPERTIES_V2,
        payload: { query, properties },
      });
      return { success: true, result: { properties: properties?.properties } };
    }

    const res = await PropertiesService.fetchLeaseProperties(payload);

    if (!res?.success || !res?.result) throw new Error('unable_to_fetch_properties');

    dispatch({
      type: types.FETCH_LEASE_PROPERTIES_V2,
      payload: { query: JSON.stringify(payload), properties: res.result },
    });
    return res;
  } catch (error) {
    dispatch(operationEnd(error));
  }
};

// this will fetch properties in case of second party initiator
export const fetchLeasePropertiesPMA = ({
  pageNumber,
  pageSize,
  propertyType,
  filters,
  defaultFilters,
  applicationId,
  isPMABank,
}) => async dispatch => {
  try {
    dispatch(operationStart());

    // const { query, properties } = getState().propertiesReducer;

    const payload = {
      pageNumber: +pageNumber,
      pageSize,
      propertyType: propertyType && +propertyType,
      ...(isPMABank && { mortgageTypeId: 1001, searchFlags: 2 }),
      ...(filters?.municipality && { municipalityID: +filters.municipality }),
      ...(filters?.district && { districtID: +filters.district }),
      ...(filters?.community && { communityID: +filters.community }),
      ...(filters?.plotNumber && { plotNumber: filters.plotNumber }),
      ...(filters?.plotAddress && { plotAddress: filters.plotAddress }),
      ...(filters?.isBlocked && { isBlocked: filters?.isBlocked === '1' || filters?.isBlocked === 1 }),
      orderByDirection: 1,
      ...(!isEmpty(filters?.bedrooms) && {
        bedrooms: [...(filters?.bedrooms || [])]?.map(item => +item),
      }),
      ...(filters?.rentStatus && { rentStatus: filters.rentStatus === '1' }),
      ...(filters?.poaOnly && { poaOnly: filters.poaOnly === 'true' }),
      ...(filters?.tenantOnly && { tenantOnly: filters.tenantOnly === 'true' }),
      ...(filters?.propertyRegNo && { propertyRegNo: `PRP${filters.propertyRegNo}` }),
      ...(filters?.unitRegNo && { unitRegNo: `UNT${filters.unitRegNo}` }),
      ...(filters?.buildingNumber && { buildingNumber: filters.buildingNumber }),
      ...(filters?.unitNumber && { unitNumber: filters.unitNumber }),
      ...defaultFilters,
    };

    const res = await PropertiesService.fetchLeasePropertiesPMA(payload, applicationId);

    if (!res?.success || !res?.result) throw new Error('unable_to_fetch_properties');
    const modifiedProperty = res?.result?.properties?.map(property => ({
      plotID: property?.plotID,
      districtNameAr: property?.districtNameAr,
      districtNameEn: property?.districtNameEn,
      districtNumber: null,
      communityID: property?.communityID,
      communityNameAr: property?.communityNameAr,
      communityNameEn: property?.communityNameEn,
      communityNumber: null,
      roadNameAr: '~',
      roadNameEn: '~',
      roadNumber: null,
      plotNumber: null,
      buildingNumber: property?.buildingNumber,
      floorNumber: null,
      unitNumber: property?.unitNumber,
      isBlocked: null,
      isMortgaged: null,
      landUseNameEn: property?.landUseNameEn,
      landUseNameAr: property?.landUseNameAr,
      unitUsageNameEn: property?.unitUsageNameEn,
      unitUsageNameAr: property?.unitUsageNameAr,
      propertyType: property?.propertyType,
      propertyTypeEn: null,
      propertyTypeAr: null,
      unitTypeEn: null,
      unitTypeAr: null,
      unitCount: property?.count,
      row_num: null,
      ownerID: null,
      municipalityID: property?.municipalityID,
      municipalityNameAr: property?.municipalityNameAr,
      municipalityNameEn: property?.municipalityNameEn,
      municipalityConst: null,
      districtID: null,
      commUnityID: null,
      commUnityNameAr: property?.communityNameAr,
      commUnityNameEn: property?.communityNameEn,
      commUnityNumber: null,
      roadID: null,
      plotAddress: null,
      flatNumber: null,
      estimatedArea: null,
      landUseID: null,
      landUseConst: null,
      parentLandUseID: null,
      parentLandUseNameAr: null,
      parentLandUseNameEn: null,
      constructedStatusID: null,
      constructedStatusNameAr: null,
      constructedStatusNameEn: null,
      serviceStatusID: null,
      serviceStatusNameAr: null,
      serviceStatusNameEn: null,
      constructionDate: null,
      lastTransactionTypeID: null,
      lastTransactionTypedate: null,
      lastTransactionTypAr: null,
      lastTransactionTypeEn: null,
      propertyTypeID: null,
      landplotID: null,
      buildingNameAr: '',
      buildingNameEn: '',
      floornumber: null,
      unitBedroomCount: null,
      unitBathroomCount: null,
      unitArea: null,
      uniT_BALCONY_AREA: null,
      unitUsageID: null,
      unitClassificationID: null,
      unitClassificationAr: property?.unitClassificationAr,
      unitClassificationEn: property?.unitClassificationEn,
      unitIsBlocked: null,
      unitIsMortgaged: null,
      plotAllocationID: null,
      plotAllocationNameAr: null,
      plotAllocationNameEn: null,
      ownershipPercentage: null,
      ownerShipTypeNameEn: null,
      ownerShipTypeNameAr: null,
      bedrooms: null,
      buildingRegNum: property?.buildingRegNum,
      unitRegNum: property?.unitRegNum,
      areaSize: null,
      landUse: null,
      premiseNumber: null,
      unitarea: null,
      owners: null,
      isLeased: null,
      isOffPlan: null,
    }));
    dispatch({
      type: types.FETCH_LEASE_PROPERTIES_V2,
      payload: { query: JSON.stringify(payload), properties: { ...res.result, properties: modifiedProperty } },
    });
    return res;
  } catch (error) {
    dispatch(operationEnd(error));
    return { success: false };
  }
};

export const fetchOwnerPropertiesV2 = ({ page, PAGE_SIZE, propertyType, filters, defaultFilters }) => async (
  dispatch,
  getState,
) => {
  try {
    dispatch(operationStart());
    const updatedDefaultFilters = { ...defaultFilters };

    const { query, properties } = getState().propertiesReducer;
    const payload = {
      pageNumber: +page,
      pageSize: PAGE_SIZE,
      propertyType: propertyType && +propertyType,
      ...(filters?.municipality && { municipalityID: +filters.municipality }),
      ...(filters?.district && { districtID: +filters.district }),
      ...(filters?.community && { communityID: +filters.community }),
      ...(filters?.plotNumber && { plotNumber: filters.plotNumber }),
      ...(filters?.plotAddress && { plotAddress: filters.plotAddress }),
      ...(filters?.isBlocked && { isBlocked: filters?.isBlocked === '1' || filters?.isBlocked === 1 }),
      ...(filters?.allocationType && { plotAllocationTypeID: +filters.allocationType }),
      ...(filters?.ownerShipTypeID && { ownerShipTypeID: +filters.ownerShipTypeID }),
      ...(filters?.isMortgaged && { isMortgaged: filters?.isMortgaged === '1' || filters?.isMortgaged === 1 }),
      ...(filters?.noOfRoom && { noOfRoom: +filters.noOfRoom }),
      ...(filters?.projectStatus && { projectStatus: +filters?.projectStatus }),
      ...(filters?.acquisitionTypeId && { acquisitionTypeId: +filters.acquisitionTypeId }),
      ...(filters?.ownershipPoaProperty && { ownershipPoaProperty: +filters.ownershipPoaProperty }),
      ...(!isEmpty(filters?.poaCustomerIds) && {
        poaCustomerIds: isArray(filters?.poaCustomerIds)
          ? [...(filters?.poaCustomerIds || [])]?.map(id => +id)?.toString()
          : [+filters?.poaCustomerIds]?.toString(),
      }),
      ...(filters?.projectId && { projectId: +filters.projectId }),
      ...(filters?.projectElmsId && { projectElmsId: +filters.projectElmsId }),
      ...(filters?.buildingNumber && { buildingNumber: filters.buildingNumber }),
      ...(filters?.floorNumber && { floorNumber: filters.floorNumber }),
      ...(filters?.unitNumber && { unitNumber: filters.unitNumber }),
      ...(filters?.unitUse && { unitUse: +filters.unitUse }),
      ...(filters?.landUse && { landUse: +filters.landUse }),
      ...(filters?.unitType && { unitType: +filters.unitType }),
      ...updatedDefaultFilters,
      ...(!!filters?.ownerShipTypeID && { searchFlags: null }),
      ...(filters?.road && { road: filters.road }),
      ...(filters?.certificateType && { certificateType: filters.certificateType }),
      ...(filters?.certificateTypePermitsLand && { certificateType: filters.certificateTypePermitsLand }),
      ...(filters?.certificateTypePermitsUnit && { certificateType: filters.certificateTypePermitsUnit }),

      ...(filters?.certificateTypePermitsLandBroker && { certificateType: filters.certificateTypePermitsLandBroker }),
      ...(filters?.certificateTypePermitsUnitBroker && { certificateType: filters.certificateTypePermitsUnitBroker }),
      ...(filters?.certificateNumber && { certificateNumber: filters.certificateNumber }),
      ...(filters?.certificateNumberPermit && { certificateNumber: filters.certificateNumberPermit }),
      ...(filters?.certificateDate && { certificateDate: filters.certificateDate }),
    };
    if (isEqual(query, JSON.stringify(payload)) && properties != null) {
      dispatch({
        type: types.FETCH_LEASE_PROPERTIES_V2,
        payload: { query, properties },
      });
      return { success: true, result: { properties: properties?.properties } };
    }

    const res = await PropertiesService.fetchOwnershipProperties(payload);

    if (!res?.success || !res?.result) throw new Error('unable_to_fetch_properties');

    dispatch({
      type: types.FETCH_LEASE_PROPERTIES_V2,
      payload: { query: JSON.stringify(payload), properties: res.result },
    });
    return res;
  } catch (error) {
    dispatch(operationEnd(error));
  }
};

export const fetchMortgagePropertiesV2 = ({ page, PAGE_SIZE, propertyType, filters, defaultFilters }) => async (
  dispatch,
  getState,
) => {
  try {
    dispatch(operationStart());
    const updatedDefaultFilters = { ...defaultFilters };
    if (filters?.projectStatus && +filters?.projectStatus === 2) {
      updatedDefaultFilters.isOffPlan = false;
    }

    const { query, properties } = getState().propertiesReducer;
    const payload = {
      pageNumber: +page,
      pageSize: PAGE_SIZE,
      propertyType: propertyType && +propertyType,
      orderByDirection: 1,
      ...(filters?.municipality && { municipalityID: +filters.municipality }),
      ...(filters?.district && { districtID: +filters.district }),
      ...(filters?.community && { communityID: +filters.community }),
      ...(filters?.plotNumber && { plotNumber: filters.plotNumber }),
      ...(filters?.plotAddress && { plotAddress: filters.plotAddress }),
      ...(filters?.isBlocked && { isBlocked: filters?.isBlocked === '1' || filters?.isBlocked === 1 }),
      ...(filters?.allocationType && { plotAllocationTypeID: +filters.allocationType }),
      ...(filters?.noOfRoom && { noOfRoom: +filters.noOfRoom }),
      ...(filters?.projectStatus && { projectStatus: +filters?.projectStatus }),
      ...(filters?.mortgageType && { mortgageType: +filters?.mortgageType }),
      ...updatedDefaultFilters,
    };
    if (isEqual(query, JSON.stringify(payload)) && properties != null) {
      dispatch({
        type: types.FETCH_LEASE_PROPERTIES_V2,
        payload: { query, properties },
      });
      return;
    }

    const res = await PropertiesService.fetchMortgageProperties(payload);

    if (!res?.success || !res?.result) throw new Error('unable_to_fetch_properties');

    dispatch({
      type: types.FETCH_LEASE_PROPERTIES_V2,
      payload: { query: JSON.stringify(payload), properties: res.result },
    });
  } catch (error) {
    dispatch(operationEnd(error));
  }
};

export const fetchBuildingProperties = buildingId => async (dispatch, getState) => {
  try {
    dispatch(operationStart());

    const isArabic = getState().language?.locale === 'ar';

    const payload = {
      orderByDirection: 1,
      pageSize: 100,
      pageNumber: 1,
      buildingId,
      propertyType: 4,
    };

    const res = await PropertiesService.fetchLeaseProperties(payload);

    const unifiedProperties = res?.result?.properties?.map(prop => ({
      ...prop,
      buildingName: isArabic ? prop?.buildingNameAr : prop?.buildingNameEn,
      communityName: isArabic ? prop?.communityNameAr : prop?.communityNameEn,
      districtName: isArabic ? prop?.districtNameAr : prop?.districtNameEn,
      landUseName: isArabic ? prop?.landUseNameAr : prop?.landUseNameEn,
      municipalityName: isArabic ? prop?.municipalityNameAr : prop?.municipalityNameEn,
      ownerShipTypeName: isArabic ? prop?.ownerShipTypeNameAr : prop?.ownerShipTypeNameEn,
      parentLandUseName: isArabic ? prop?.parentLandUseNameAr : prop?.parentLandUseNameEn,
      plotAllocationName: isArabic ? prop?.plotAllocationNameAr : prop?.plotAllocationNameEn,
      lastTransactionType: isArabic ? prop?.lastTransactionTypeAr : prop?.lastTransactionTypeEn,
      serviceStatusName: isArabic ? prop?.serviceStatusNameAr : prop?.serviceStatusNameEn,
      unitClassification: isArabic ? prop?.unitClassificationAr : prop?.unitClassificationEn,
      unitType: isArabic ? prop?.unitTypeAr : prop?.unitTypeEn,
      unitUsageName: isArabic ? prop?.unitUsageNameAr : prop?.unitUsageNameEn,
    }));

    dispatch({ type: types.FETCH_BUILDING_UNITS });
    return { ...res, result: { ...res.result, properties: unifiedProperties } };
  } catch (error) {
    dispatch(operationEnd(error));
    return error;
  }
};

export const fetchBuildingWithoutPage = buildingId => async (dispatch, getState) => {
  try {
    dispatch(operationStart());

    const isArabic = getState().language?.locale === 'ar';

    // const payload = {
    //   orderByDirection: 1,
    //   pageSize: 100,
    //   pageNumber: 1,
    //   buildingId,
    //   propertyType: 4,
    // };

    const res = await PropertiesService.fetchBuildingWithoutPage(buildingId);

    const unifiedProperties = res?.result?.units?.map(prop => ({
      ...prop,
      buildingName: isArabic ? prop?.buildingNameAr : prop?.buildingNameEn,
      communityName: isArabic ? prop?.communityNameAr : prop?.communityNameEn,
      districtName: isArabic ? prop?.districtNameAr : prop?.districtNameEn,
      landUseName: isArabic ? prop?.landUseNameAr : prop?.landUseNameEn,
      municipalityName: isArabic ? prop?.municipalityNameAr : prop?.municipalityNameEn,
      ownerShipTypeName: isArabic ? prop?.ownerShipTypeNameAr : prop?.ownerShipTypeNameEn,
      parentLandUseName: isArabic ? prop?.parentLandUseNameAr : prop?.parentLandUseNameEn,
      plotAllocationName: isArabic ? prop?.plotAllocationNameAr : prop?.plotAllocationNameEn,
      lastTransactionType: isArabic ? prop?.lastTransactionTypeAr : prop?.lastTransactionTypeEn,
      serviceStatusName: isArabic ? prop?.serviceStatusNameAr : prop?.serviceStatusNameEn,
      unitClassification: isArabic ? prop?.unitClassificationAr : prop?.unitClassificationEn,
      unitType: isArabic ? prop?.unitTypeAr : prop?.unitTypeEn,
      unitUsageName: isArabic ? prop?.unitUsageNameAr : prop?.unitUsageNameEn,
    }));
    dispatch({ type: types.FETCH_BUILDING_UNITS });
    return { ...res, result: { ...res.result, units: unifiedProperties } };
  } catch (error) {
    dispatch(operationEnd(error));
    return error;
  }
};
export const fetchPoaCustomers = () => async dispatch => {
  try {
    dispatch({ type: types.FETCH_POA_CUSTOMER });
    const response = await OwnerService.fetchPoaCustomers();
    dispatch({
      type: types.FETCH_POA_CUSTOMER_SUCCESS,
      payload: {
        customers: response?.result,
      },
    });
  } catch (error) {
    dispatch({ type: types.FETCH_POA_CUSTOMER_FAILURE, payload: error });
  }
};
export const clearPoaCustomers = () => async dispatch => {
  dispatch({ type: types.FETCH_POA_CUSTOMER_FAILURE });
  // const response = await OwnerService.fetchPoaCustomers();
};

export const fetchOffPlanProjects = () => async dispatch => {
  try {
    dispatch({ type: types.FETCH_OFF_PLAN_PROJECTS });
    const response = await AuthService.fetchOffPlanProjects();
    dispatch({
      type: types.FETCH_OFF_PLAN_PROJECTS_SUCCESS,
      payload: {
        projects: response?.projects,
      },
    });
  } catch (error) {
    dispatch({ type: types.FETCH_OFF_PLAN_PROJECTS_FAILURE, payload: error });
  }
};

export const fetchOffPlanUnitUsage = () => async dispatch => {
  try {
    dispatch({ type: types.FETCH_OFF_PLAN_UNIT_USAGE });
    const response = await AuthService.fetchOffPlanUnitUsage();
    dispatch({
      type: types.FETCH_OFF_PLAN_UNIT_USAGE_SUCCESS,
      payload: {
        unitUsage: response?.unitUses,
      },
    });
  } catch (error) {
    dispatch({ type: types.FETCH_OFF_PLAN_UNIT_USAGE_FAILURE, payload: error });
  }
};

export const fetchOffPlanUnitTypes = () => async dispatch => {
  try {
    dispatch({ type: types.FETCH_OFF_PLAN_UNIT_TYPES });
    const response = await AuthService.fetchOffPlanUnitTypes();
    dispatch({
      type: types.FETCH_OFF_PLAN_UNIT_TYPES_SUCCESS,
      payload: {
        unitTypes: response?.unitTypes,
      },
    });
  } catch (error) {
    dispatch({ type: types.FETCH_OFF_PLAN_UNIT_TYPES_FAILURE, payload: error });
  }
};

export const fetchMortgageTypes = () => async dispatch => {
  try {
    dispatch({ type: types.FETCH_MORTGAGE_TYPES });
    const response = await MortgageService.fetchMortgageTypes();
    dispatch({
      type: types.FETCH_MORTGAGE_TYPES_SUCCESS,
      payload: {
        mortgageTypes: response?.items,
      },
    });
  } catch (error) {
    dispatch({ type: types.FETCH_MORTGAGE_TYPES_FAILURE, payload: error });
  }
};

export const fetchPMCProperties = ({ page, PAGE_SIZE, filters }) => async (dispatch, getState) => {
  try {
    dispatch(operationStart());
    let res = [];
    let payload = [];
    if (filters?.workflowId && filters?.certificateNo) {
      const { query, properties } = getState().propertiesReducer;
      const propertyType =
        filters?.workflowId === types.WORKFLOW_ID_CERT_SITE_PLAN_PLOT ||
        filters?.workflowId === types.WORKFLOW_ID_CERT_VERIFICATION_PLOT ||
        filters?.workflowId === types.WORKFLOW_ID_TITLE_DEED_PLOT
          ? 2
          : 4;
      payload = {
        pageNumber: +page,
        pageSize: PAGE_SIZE,
        propertyType,
        orderByDirection: 1,
        ...(filters?.workflowId &&
          filters?.certificateNo && {
            workflowId: filters.workflowId,
            mortgageTypeId: 1001,
            searchFlags: 3,
            certificateNumber: `${filters.prefix}/${filters.certificateNo}`,
          }),
      };
      if (isEqual(query, JSON.stringify(payload)) && properties != null) {
        dispatch({
          type: types.FETCH_LEASE_PROPERTIES_V2,
          payload: { query, properties },
        });
        return;
      }

      res = await PropertiesService.fetchLeaseProperties(payload);

      if (!res?.success || !res?.result) throw new Error('unable_to_fetch_properties');
    } else {
      res.result = [];
      payload = {};
    }

    dispatch({
      type: types.FETCH_LEASE_PROPERTIES_V2,
      payload: { query: JSON.stringify(payload), properties: res.result },
    });
  } catch (error) {
    dispatch(operationEnd(error));
  }
};
